import { useCallback, useMemo, useState } from 'react';
import type { LinkedContactNote } from '../../LinkedContactNotesGrid';
import { toContactNoteUids } from '../../mappers/contactNoteMapper';

/**
 * Holds the contact notes linked in a modal during this session and the UIDs to send with the save
 * request. Notes arrive from the contact-note remote through `LinkContactNotesButton`.
 *
 * @returns the linked notes, the updater for `LinkContactNotesButton`, and the sendable UIDs.
 */
export const useLinkedContactNotes = () => {
  const [notes, setNotes] = useState<LinkedContactNote[]>([]);

  const changeNotes = useCallback(
    (update: (current: LinkedContactNote[]) => LinkedContactNote[]) => setNotes(update),
    [],
  );
  const contactNoteUids = useMemo(() => toContactNoteUids(notes), [notes]);

  return { notes, changeNotes, contactNoteUids };
};
